const PaginationTypes = {
  none: -1,
  showMore: 1,
};

export default PaginationTypes;
